export const updateStorageItem = (itemKey, value) => {
  if (value) {
    localStorage.setItem(itemKey, value);
  } else {
    localStorage.removeItem(itemKey);
  }
};
